// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8792) return "main.3e615354.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"117":"32f60acf","2170":"cbbf064a","2718":"dc9fe5f8"}[chunkId] + ".chunk.css";
};